import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { registrationService } from '@/services/registration.service';

export default function RecentUsers() {
  const [users, setUsers] = useState<any[]>([]);

  useEffect(() => {
    registrationService.list().then((all) => setUsers(all.slice(0, 5)));
  }, []);

  return (
    <div className="bg-white rounded-2xl border-2 border-rose-100 p-5">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-gray-800 text-sm">נרשמים אחרונים</h3>
        <Link to="/admin/users" className="text-xs text-rose-400 hover:text-rose-500 font-medium cursor-pointer">
          הצג הכל ←
        </Link>
      </div>
      <div className="space-y-2">
        {users.map((user) => (
          <div key={user.id} className="flex items-center gap-3 p-3 rounded-xl hover:bg-rose-50/50 transition-all">
            <div className="w-8 h-8 flex items-center justify-center rounded-full bg-rose-100 text-rose-500 font-bold text-sm flex-shrink-0">
              {(user.name || '?').charAt(0)}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-gray-700">{user.name || 'אורח'}</p>
              <p className="text-xs text-gray-400 truncate">{user.registerable?.title || user.registerable?.company || ''}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
